import axios from "axios";
import { ChargeStatus, MoveState, QueryRobotInfo, RobotDetailData, RobotState, rMapRobotState } from "../types/Robot";
import { LocationData } from "../types/Location";

export const listRobots = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return{
            status: 200,
            data: [{
                "id": 1,
                "name": "Flashboy",
                "robotType": 1,
                "displayRobot": true,
                "move_state": MoveState.IDLE,
                "robot_state": RobotState.FREE,
                "charge_state": ChargeStatus.CHARGEFULLUSEPILE,
                "battery": 100,
                "time_lock": "2023-05-21T06:07:00+08:00",
                "location": {
                    "id": 53,
                    "displayName": "L1Charge",
                    "image": new File([new Blob([], { type: 'application/octet-stream' })] , "./assets/robots/flashbot.png", {
                            type: 'application/octet-stream',
                            lastModified: Date.now(),
                        }),
                    "map": "9",
                    "name": "L1Charge",
                    "locationType": 3,
                    "display": true,
                } as LocationData,
                "door_open": false,
                "robot_mode": 1
            }].map( (robot: {
                id: number,
                name: string,
                battery: number,
                robotType: number,
                displayRobot: boolean,
                move_state: MoveState,
                robot_state: RobotState,
                charge_state: ChargeStatus,
                location: LocationData,
                door_open: boolean,
            }) => {
                return {
                        ...robot,
                    image: "./assets/robots/flashbot.png"
                }
            })
        }
}

export const listRobotsInfos = async (data: QueryRobotInfo) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    // console.log(data)

    return {
        status: 200,
        data: [{
            "id": 1,
            "name": "Flashboy",
            "robotType": 1,
            "displayRobot": true,
            "move_state": MoveState.IDLE,
            "robot_state": RobotState.FREE,
            "charge_state": ChargeStatus.CHARGEFULLUSEPILE,
            "battery": 100,
            "time_lock": "2023-05-21T06:07:00+08:00",
            "location": {
                "id": 53,
                "displayName": "L1Charge",
                "image": new File([new Blob([], { type: 'application/octet-stream' })] , "./assets/robots/flashbot.png", {
                        type: 'application/octet-stream',
                        lastModified: Date.now(),
                    }),
                "map": "9",
                "name": "L1Charge",
                "locationType": 3,
                "display": true,
            } as LocationData,
            "door_open": false,
            "robot_mode": 1
        }].map( (robot: {
            id: number,
            name: string,
            battery: number,
            robotType: number,
            displayRobot: boolean,
            move_state: MoveState,
            robot_state: RobotState,
            charge_state: ChargeStatus,
            location: LocationData,
            door_open: boolean,
        }) => {
            return {
                    ...robot,
                image: "./assets/robots/flashbot.png"
            }
        })
    }
}

export const getRobotStatus = async (id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return await axios.get("/api/robots/" + String(id) + "/").then(response => {
        return {
            status: response.status,
            data: {
                ...response.data,
                image: "./assets/robots/flashbot.png", // backend not supported yet
            }
        }
    }).catch(e => {
        return {
            status: e.response.status,
            data: e.response.data
        };
   });
}

export const getRobotDoorStatus = async (id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
            status:200,
            data: []
        };
}

export const postCloseRobotDoors = async (id: number) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        status:200,
        data: []
    };
}

export const postOpenDoor = async (doorsStates: boolean[]) => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";

    return {
        status:200,
        data: []
    };
}

export const getSimulateRobotTouchScreen = async () => {
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.xsrfCookieName = "csrftoken";
    return {
        status:200,
        data: []
    };
}